import { pdf } from '@react-pdf/renderer';
import { arrowLeft } from 'assets';
import { Button, DatePickerField, Modal } from 'components';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import SelectField from 'components/Forms/SelectField';
import saveAs from 'file-saver';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { dayjs, yup } from 'libs';
import { flatten, uniqueId } from 'lodash';
import React, { FC, useCallback, useEffect, useState, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { shopService, siteService, workerService } from 'services';
import * as Types from 'types';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { siteUserStatusAdapterSelectors } from '../selectors';
import { layoutSelector } from '../../../containers/Layout/selectors';
import SectionStyled, { HeaderStyle } from './styles';
import { TablePDF } from './TablePdf';
// 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
// interface Props {
//   dataCooperator: { header: string; title: string; key: string | number; code: string }[];
//   LockStatusData?: Types.GetSiteStatusLockedResponse | null;
// }
type CooperatorOption = { label: string; value: string; code: string };
// const ModalOutputRKY: FC<Props> = ({ dataCooperator }) => {
const ModalOutputRKY: FC = () => {
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  const [visible, setVisible] = useState<boolean>(false);
  const user_statuses = useSelector(siteUserStatusAdapterSelectors.selectAll);
  const { LockStatusData } = useSelector(layoutSelector);
  const dateFormat = 'YYYY/MM/DD';
  const systemChangeDay: number = 20250401;
  const { buildingId } = useParams<{ buildingId: string }>();
  // 2023/05/05 Leading Win RKY出力ない場合提示メッセージ追加 start
  const [noRkyFlag, setNoRkyFlag] = useState<boolean>(false);
  const [outputLoadingExport, setOutputLoadingExport] = useState(false);
  const [total, setTotal] = useState(0);
  const [processing, setProcessing] = useState(0);
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
  // const ModalOutputRKY: FC<Props> = ({ dataCooperator }) => { ... }
  const [cooperatorOptions, setCooperatorOptions] = useState<CooperatorOption[]>([]);
  const [cooperatorLoading, setCooperatorLoading] = useState(false);
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const currentDayParams = query.get('currentDay')
    ? dayjs(query.get('currentDay')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');

  // 2023/05/05 Leading Win RKY出力ない場合提示メッセージ追加 end
  const formik = useFormik({
    initialValues: {
      cooperator_id: '',
      from_date: currentDayParams,
      // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
      // to_date: '',
      to_date: currentDayParams,
      // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
    },
    enableReinitialize: true,
    validationSchema,
    async onSubmit(values) {
      try {
        // 2023/05/05 Leading Win RKY出力ない場合提示メッセージ追加 start
        // if (dataCooperator.length === 0) {
        if (cooperatorOptions.length === 0) {
          setNoRkyFlag(true);
          return;
        }
        // 2023/05/05 Leading Win RKY出力ない場合提示メッセージ追加 end
        setOutputLoadingExport(true);
        if (values.cooperator_id === '全て') {
          // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
          // setTotal(dataCooperator.length);
          setTotal(cooperatorOptions.length);
          // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
          setProcessing(0);
        } else {
          setTotal(1);
          setProcessing(1);
        }
        // 2025/03/24 Leading Win RKY出力修正 start
        if (values.cooperator_id === '全て') {
          // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
          // for (const i of dataCooperator.filter((i) => i.key !== '全て')) {
          //   setProcessing((prev) => prev + 1);
          //   await getDataExport({
          //     ...values,
          //     cooperator_id: i.key,
          //     nameCooperator: i.header,
          //     cooperator_code: i.code,
          //     from_date: values.from_date,
          //     to_date: values.to_date,
          //   });
          // }
          for (const option of cooperatorOptions) {
            setProcessing((prev) => prev + 1);
            await getDataExport({
              ...values,
              cooperator_id: option.value,
              nameCooperator: option.label,
              cooperator_code: option.code,
              from_date: values.from_date,
              to_date: values.to_date,
            });
          }
          // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
        } else {
          const nameCooperator =
            // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
            // dataCooperator.find((i) => values.cooperator_id == i.key)?.header ?? '';
            cooperatorOptions.find((i) => values.cooperator_id == i.value)?.label ?? '';
          await getDataExport({
            ...values,
            nameCooperator,
            // cooperator_code: dataCooperator.find((i) => values.cooperator_id == i.key)?.code ?? '',
            cooperator_code:
              cooperatorOptions.find((i) => values.cooperator_id == i.value)?.code ?? '',
            from_date: values.from_date,
            to_date: values.to_date,
          });
          // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
        }
      } catch (e) {
        console.log(e);
      } finally {
        setOutputLoadingExport(false);
        setVisible(false);
        formik.resetForm();
        // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
        setCooperatorOptions([]);
        // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
      }
    },
  });
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
  const { setFieldValue } = formik;
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  const getDataExport = useCallback(
    async ({
      nameCooperator,
      cooperator_id,
      cooperator_code,
      from_date,
      to_date,
    }: {
      nameCooperator: string;
      cooperator_id: number | string;
      cooperator_code: string;
      from_date: string;
      to_date: string;
    }) => {
      console.log('----- getDataExport params-----');
      console.log('building_id:', buildingId);
      console.log('nameCooperator:', nameCooperator);
      console.log('cooperator_id:', cooperator_id);
      console.log('cooperator_code:', cooperator_code);
      console.log('from_date:', from_date);
      console.log('to_date:', to_date);

      const getDataLabel = `getSiteOutputRKYList-${Date.now()}`;
      console.time(getDataLabel);
      const response = await siteService.getSiteOutputRKYList({
        building_id: buildingId,
        cooperator_id: String(cooperator_id),
        first_cooperator_code: cooperator_code,
        start_date: from_date,
        end_date: to_date,
      });
      const list: Types.SiteRKYDataListResponse[] = response.data;
      console.timeEnd(getDataLabel);

      console.log('----- getSiteOutputRKYList data:', JSON.stringify(list, null, 2));
      if (list.length > 0) {
        const generatePDF = `generatePDF-${Date.now()}`;
        console.time(generatePDF);
        const pdfDownload = await pdf(
          <TablePDF
            key={uniqueId()}
            data={list}
            nameCooperator={nameCooperator || '全て'}
            siteUserStatus={user_statuses}
            LockStatusData={LockStatusData}
          />
        ).toBlob();
        console.timeEnd(generatePDF);
        if (pdfDownload) {
          saveAs(
            pdfDownload,
            `RKY_${LockStatusData?.site_name}_${nameCooperator || '全て'}_${dayjs(from_date).format(
              'YYYYMMDD'
            )}_${dayjs(to_date).format('YYYYMMDD')}`
          );
        }
      } else {
        toast.error(
          <div>
            <strong>{nameCooperator}</strong>
            <div>
              選択された出力期間内に対象業者のRKYデータが存在しません。出力期間を見直してください。
            </div>
          </div>
        );
      }
    },
    // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
    // [LockStatusData, buildingId, user_statuses]
    [LockStatusData, buildingId, cooperatorOptions, user_statuses]
    // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  );
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  const fetchCooperatorOptions = useCallback(
    async (fromDate: string, toDate: string) => {
      if (!buildingId) return;
      const start = dayjs(fromDate);
      const end = dayjs(toDate);
      if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
        setCooperatorOptions([]);
        setFieldValue('cooperator_id', '', false);
        return;
      }
      try {
        setCooperatorLoading(true);
        const response = await siteService.getSiteOutputCooperatorList({
          building_id: Number(buildingId),
          from_date: start.format('YYYY-MM-DD'),
          to_date: end.format('YYYY-MM-DD'),
        });
        const options =
          response.data?.cooperators?.map((item) => ({
            label: item.company_name ?? '',
            value: item.cooperator_id ?? '',
            code: item.cooperator_code ?? '',
          })) ?? [];
        setCooperatorOptions(options);
        setFieldValue('cooperator_id', '', false);
      } catch (error) {
        console.error(error);
        setCooperatorOptions([]);
        setFieldValue('cooperator_id', '', false);
        toast.error('協力業者一覧の取得に失敗しました。');
      } finally {
        setCooperatorLoading(false);
      }
    },
    [buildingId, setFieldValue]
  );

  // 出力期間変更時に協力業者一覧を再取得する
  useEffect(() => {
    if (!visible) return;
    if (!formik.values.from_date || !formik.values.to_date) return;
    fetchCooperatorOptions(formik.values.from_date, formik.values.to_date);
  }, [visible, formik.values.from_date, formik.values.to_date, fetchCooperatorOptions]);

  const selectOptions = useMemo(
    () => [
      ...cooperatorOptions.map((item) => ({
        label: item.label,
        value: item.value,
      })),
      { label: '全て', value: '全て' },
    ],
    [cooperatorOptions]
    // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  );

  return (
    <>
      <Button onClick={() => setVisible(true)} size="small">
        RKY表の出力
      </Button>
      <Modal
        title={
          <HeaderStyle>
            <img
              src={arrowLeft}
              onClick={() => {
                formik.resetForm();
                setVisible(false);
                // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
                setCooperatorOptions([]);
                // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
              }}
              alt="arrowLeft"
            />
            <div>RKYの出力</div>
          </HeaderStyle>
        }
        visible={visible}
        footer={false}
        destroyOnClose
        width={560}
      >
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form" preserve={false}>
              <div className="group-input">
                <div className="box-select">
                  <Form.Item className="input-onsite" label="現場" colon={false} name="sitename">
                    <div className="titleSiteName">
                      {LockStatusData && LockStatusData.site_name}
                    </div>
                  </Form.Item>
                </div>
                <div className="box-select">
                  <Form.Item
                    className="input-onsite"
                    label="出力期間"
                    colon={false}
                    name="from_date"
                  >
                    <DatePickerField
                      name="from_date"
                      format={dateFormat}
                      placeholder="開始日を選択"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                  <div className="center-text">〜</div>
                  <Form.Item className="select-date" label={<span />} name="to_date">
                    <DatePickerField
                      name="to_date"
                      disabled={!formik.values.from_date}
                      format={dateFormat}
                      placeholder="終了日を選択"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                      defaultPickerValue={
                        formik.values.to_date
                          ? moment(formik.values.to_date)
                          : formik.values.from_date
                          ? moment(formik.values.from_date)
                          : moment()
                      }
                    />
                  </Form.Item>
                </div>
                <div className="box-select">
                  <Form.Item className="input-onsite" label="業者" colon={false} name="trader">
                    <SelectField
                      data={selectOptions}
                      name="cooperator_id"
                      className="select-field"
                      placeholder="業者を選択してください"
                      // 日付未選択時も操作できないよう制御
                      disabled={
                        cooperatorLoading || !formik.values.from_date || !formik.values.to_date
                      }
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="ant-modal-footer">
                <Button
                  className="button-secondary"
                  disabled={formik.isSubmitting}
                  onClick={() => {
                    setVisible(false);
                    formik.resetForm();
                    setCooperatorOptions([]);
                  }}
                >
                  キャンセル
                </Button>
                <ButtonSubmit
                  disabled={!formik.isValid || !formik.dirty}
                  loading={outputLoadingExport}
                >
                  {outputLoadingExport ? `出力中[${processing}/${total}]` : '出力'}
                </ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
      {/* 2023/05/05 Leading Win RKY出力ない場合提示メッセージ追加 start */}
      <Modal
        title="出力するRKY表が存在しません"
        visible={noRkyFlag}
        width={340}
        cancelButton={{
          text: '確定',
          onClick: () => setNoRkyFlag(false),
        }}
      ></Modal>
      {/* 2023/05/05 Leading Win RKY出力ない場合提示メッセージ追加 end */}
      {/* <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
    </>
  );
};

export default ModalOutputRKY;

const initialValues = {
  cooperator_id: '',
  from_date: '',
  to_date: '',
};

const validationSchema = yup.object().shape({
  cooperator_id: yup.string().required('業者を選択してください。'),

  from_date: yup
    .date()
    .nullable()
    .required('開始日を選択してください。')

    .test({
      name: 'from_date_range',
      message: '開始日は終了日の6ヶ月前までの範囲で選択してください。',
      test: function (fromDate) {
        const { to_date } = this.parent;
        if (!fromDate || !to_date) return true;
        const sixMonthsBefore = dayjs(to_date).subtract(6, 'month').startOf('day');
        return dayjs(fromDate).isSameOrAfter(sixMonthsBefore);
      },
    }),
  // .test({
  //   name: 'from_date_no_cross_apr',
  //   message:
  //     '2025年3月31日から2025年4月1日をまたぐ期間の出力には対応していません。期間を変更して再試行してください。',
  //   test: function (fromDate) {
  //     const { to_date } = this.parent;
  //     if (!fromDate || !to_date) return true;
  //     const pivot = dayjs('2025-04-01');
  //     const fromIsAfterOrSame = dayjs(fromDate).isSameOrAfter(pivot);
  //     const toIsAfterOrSame = dayjs(to_date).isSameOrAfter(pivot);
  //     return fromIsAfterOrSame === toIsAfterOrSame;
  //   },
  // }),

  to_date: yup
    .date()
    .nullable()
    .required('終了日を選択してください。')
    .test({
      name: 'to_date_range',
      message: '終了日は開始日の6ヶ月以内の日付を入力してください。',
      test: function (toDate) {
        const { from_date } = this.parent;
        if (!toDate || !from_date) return true;
        const sixMonthsAfter = dayjs(from_date).add(6, 'month').endOf('day');
        return dayjs(toDate).isSameOrBefore(sixMonthsAfter);
      },
    })
    .when('from_date', (fromDate, schema) => {
      if (fromDate && dayjs(fromDate).isValid()) {
        return schema.min(
          dayjs(fromDate).startOf('day').toDate(),
          '終了日は開始日以降の日付を入力してください。'
        );
      }
      return schema;
    })
    .test({
      name: 'to_date_no_cross_apr',
      message:
        '2025年3月31日から2025年4月1日をまたぐ期間の出力には対応していません。期間を変更して再試行してください。',
      test: function (toDate) {
        const { from_date } = this.parent;
        if (!toDate || !from_date) return true;
        const pivot = dayjs('2025-04-01');
        const fromIsAfterOrSame = dayjs(from_date).isSameOrAfter(pivot);
        const toIsAfterOrSame = dayjs(toDate).isSameOrAfter(pivot);
        return fromIsAfterOrSame === toIsAfterOrSame;
      },
    }),
});
